import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    window.dispatchEvent(new Event("tro-installable"));
  });
}

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export const InstallButton = () => {
  const [ready, setReady] = useState(!!deferred || (isIOS() && !standalone()));
  useEffect(() => {
    const on = () => setReady(true);
    const off = () => { deferred = null; setReady(false); toast.success("TRO installed on this device"); };
    window.addEventListener("tro-installable", on);
    window.addEventListener("appinstalled", off);
    return () => { window.removeEventListener("tro-installable", on); window.removeEventListener("appinstalled", off); };
  }, []);
  if (!ready || standalone()) return null;
  const install = async () => {
    if (!deferred) return toast.info("To install TRO: tap Share, then 'Add to Home Screen'");
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") { deferred = null; setReady(false); }
  };
  return (
    <button data-testid="install-app-btn" aria-label="Install TRO" title="Install TRO" onClick={install} className="inline-flex items-center gap-1.5 rounded-full bg-[#17191C] px-3 py-1.5 text-xs font-bold text-white transition-transform hover:-translate-y-0.5">
      <Download className="h-3.5 w-3.5" /><span className="hidden sm:inline">Install TRO</span>
    </button>
  );
};
